module.exports = __webpack_public_path__ + "img/afbf6d5cb73414355ea181223280fedc.png";